import React, { useRef, useState, useEffect, LegacyRef } from "react";
import { KontentRichText, PageLink } from "../../../types";
import CloseButton from "../../elements/CloseButton/CloseButton";
import { Cta } from "../../elements/Cta/Cta";
import { CustomRichTextElement } from "../../elements/CustomRichTextElement/CustomRichTextElement";
import * as styles from "./Alert.module.css";
import Cookies from "js-cookie";
import { AlertStyles, AlertAlignment } from ".";

interface Props {
  style: AlertStyles;
  text: KontentRichText;
  cta: PageLink;
  id: string;
  alignment?: AlertAlignment;
}

export const Alert: React.FC<Props> = ({ style, text, cta, id, alignment }) => {
  const [visible, setVisible] = useState(false);
  const [bannerElHeight, setBannerElHeight] = useState(200);
  const containerEl = useRef(null);
  const bannerCookieName = `banner${id}`;
  const invert = style !== "dark";

  const containerStyles = [styles.alert];
  !visible && containerStyles.push(styles.hidden);
  style === "light" && containerStyles.push(styles.light);
  style === "transparent" && containerStyles.push(styles.transparent);
  style === "red" && containerStyles.push(styles.red);
  style === "gold" && containerStyles.push(styles.gold);
  alignment === "center" && containerStyles.push(styles.center);

  const handleCloseButtonClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setVisible(!visible);
    Cookies.set(bannerCookieName, "true", { secure: true });
  };

  useEffect(() => {
    setBannerElHeight(containerEl?.current?.offsetHeight || 200);
  }, [containerEl.current]);

  useEffect(() => {
    const consent = Cookies.get(bannerCookieName);

    if (!consent) {
      setVisible(true);
    }
  }, []);

  return (
    <>
      <div
        data-kontent-component-id={id}
        className={containerStyles.join(" ")}
        ref={containerEl}
      >
        <CustomRichTextElement
          content={text}
          data-kontent-element-codename="text"
        />
        {cta?.href && cta?.label && (
          <Cta
            {...cta}
            invert={invert}
            buttonStyle={invert ? "turquoise" : undefined}
            data-kontent-element-codename="link_configuration__link"
          />
        )}
        <CloseButton
          onClick={handleCloseButtonClick}
          color={invert ? "var(--color-navy)" : "var(--color-white)"}
        />
      </div>
    </>
  );
};
